import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import FormEditDireccion from './FormEditDireccion';
import FormEditDestinatario from './FormEditDestinatario';


import { useForm, FormContext } from "react-hook-form";
import { Button, Grid, IconButton, Typography, makeStyles } from "@material-ui/core";

const useStyles= makeStyles({
  titulo:{
    marginTop : "10px",
    marginRight:"10px",
    marginLeft:"10px",
    display: "flex",
    justifyContent:"space-between",
    alignItems :"center"
  }
})

const EditDireccionesCards = ({direccion,handleEditData,cancelEdit,destinatario}) => {
  const classes = useStyles();
  const onSubmit=(data)=>{
    handleEditData(data)
  }
  const methods = useForm();
    return ( 
      <FormContext {...methods}>
        
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Grid container spacing={2} style={{}}>
          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.titulo}>
              <Typography variant="h5" component="h2"> Editando Carta </Typography>
              <IconButton  onClick={cancelEdit}> <CloseIcon /> </IconButton>
            </div>
          <FormEditDestinatario destinatario={destinatario}/>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
          <FormEditDireccion direccion={direccion}/>
          </Grid>
          <Button  style={{margin:"20px",display:"block",width:"100%"}}variant="contained"color="primary" type="submit">
            ACTUALIZAR
          </Button>
        </Grid>
      </form>
    </FormContext>
        
     )
}
 
export default EditDireccionesCards;